import { render } from "./ui-radio-buttons.vue?vue&type=template&id=672bbdb0&ts=true"
import script from "./ui-radio-buttons.vue?vue&type=script&lang=ts"
export * from "./ui-radio-buttons.vue?vue&type=script&lang=ts"

import "./ui-radio-buttons.vue?vue&type=style&index=0&id=672bbdb0&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__